// extracted by mini-css-extract-plugin
export default {"wrapper":"BuyPlants_wrapper__hyI6v","block":"BuyPlants_block__8hbIx"};